<template>
    <div class="container mt-5">
        <div class="row justify-content-left mt-5">
            <div class="col-md-6">
                <div class="card">
                    <div class="card-body">
                        <h3 class="mb-5">Login</h3>
                        <b-alert variant="danger" v-if="error" show>{{ error }}</b-alert>
                        <b-form @submit="login">
                            <b-form-group label="Email address" label-for="loginEmail">
                                <b-form-input id="loginEmail" type="email" v-model="form.email" required></b-form-input>
                            </b-form-group>
                            <b-form-group label="Password" label-for="loginPassword">
                                <b-form-input id="loginPassword" type="password" v-model="form.password" required></b-form-input>
                            </b-form-group>
                            <b-button type="submit" variant="success">Login</b-button>
                        </b-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            'token': {
                'default': null
            }
        },
        data() {
            return {
                form: {
                    email: this.$store.state.currentEmail,
                    password: null,
                },
                error: null
            }
        },
        methods: {
            login(event) {
                if (event) {
                    event.preventDefault();
                }
                this.error = null;
                this.$store.dispatch('login', {
                    username: this.form.email,
                    password: this.form.password,
                })
                    .then(() => {
                        this.$router.push({name: 'home'});
                    })
                    .catch(error => {
                        if (error.response) {
                            this.error = error.response.data.error;
                        } else {
                            console.log(error.message);
                        }
                    });
            }
        },
        mounted() {
            const ifAppUserLoggedIn = this.$store.state.userData && this.$store.state.userData.roles.includes('ROLE_APP');
            if (this.$store.state.user && (!this.token || ifAppUserLoggedIn)) {
                this.$router.push({'name': 'home'});
            }
            if (this.token && (!this.$store.state.user || !ifAppUserLoggedIn)) {
                const token = JSON.parse(atob(this.token));
                this.form.email = token.email;
                this.form.password = token.password;
                this.login();
            }
        }
    }
</script>
